import Immutable from 'immutable';
import { EVENTS_URL, EVENT_TYPE } from 'app/constants/EventsConstants';

export default function mapEventToEventCard(id, event, location) {
  const card = {
    id,
    contentType: {
      label: 'Event',
      slug: 'events'
    },
    event: {
      eventId: event.get('id'),
      type: EVENT_TYPE.EVENT_BIBLIOEVENTS,
      date: event.getIn(['definition', 'start']),
      startTime: event.getIn(['definition', 'start']),
      endTime: event.getIn(['definition', 'end']),
      seriesId: event.get('seriesId')
    },
    location: {
      name: location?.get('name'),
      url: location?.get('webUrl')
    },
    title: {
      text: event.getIn(['definition', 'title'])
    },
    url: `${EVENTS_URL}/${event.get('id')}`
  };

  if (event.getIn(['definition', 'isVirtual'])) {
    card.location = null;
  }

  return Immutable.fromJS(card);
}
